// extracted by mini-css-extract-plugin
export default {"section1":"Section1_section1__G4Ux+","headText":"Section1_headText__HasQe"};